import { FC, useState } from 'react';
import {
  Button,
  Radio,
  RadioGroup,
  Spacer,
  TextTitle,
} from '@pypestream/design-system';
import { TranslationComponent } from '@pypestream/translations';

import { GenericModal, GenericModalProps } from '..';

export type LoadAsDraftModalProps = GenericModalProps;

export const LoadAsDraftModal: FC<LoadAsDraftModalProps> = ({
  modalRef,
  onClose,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <GenericModal
      test-id="load-as-draft-modal"
      modalRef={modalRef}
      onClose={onClose}
      onError={() => setIsLoading(false)}
    >
      <TextTitle size="small">
        <TranslationComponent i18nKey="pro-studio/versions:load_as_draft_modal.title.part1">
          Load
        </TranslationComponent>{' '}
        <span color="primary">v4</span>{' '}
        <TranslationComponent i18nKey="pro-studio/versions:load_as_draft_modal.title.part2">
          as draft
        </TranslationComponent>
      </TextTitle>
      <Spacer size="small" />
      <RadioGroup size="large">
        <Radio value="1">
          <TranslationComponent i18nKey="pro-studio/versions:load_as_draft_modal.radio_group.radio1">
            Restore all files
          </TranslationComponent>
        </Radio>
        <Radio value="2">
          <TranslationComponent i18nKey="pro-studio/versions:load_as_draft_modal.radio_group.radio2">
            Restore without Actions
          </TranslationComponent>
        </Radio>
      </RadioGroup>
      <Button size="large" slot="footer" onClick={onClose} disabled={isLoading}>
        <TranslationComponent i18nKey="pro-studio/versions:load_as_draft_modal.button">
          Confirm
        </TranslationComponent>
      </Button>
    </GenericModal>
  );
};
